import GoToAll from "components/shared/go-to-all";
import { paymentStatuses } from "constants/statuses";
import { memo } from "react"

const OrderState = props => {
    const { data } = props;

    return (
        <div className="wrap-box tp-22 mb-4">
            <div className="financial-state">
                <div className="flex items-center justify-between mb-2 reset-i">
                    <h2 className="title tp-34">وضعیت سفارشات</h2>
                    <GoToAll link="/panel/order" />
                </div>

                <div className="max-h-48 overflow-auto spec-sb-c2 pl-4">
                    <ul>
                        {
                            paymentStatuses.map(status => (
                                <li key={`order-status-${status.id}`}>
                                    <div>
                                        <span className="sec-title tp-34">{status.title}</span>
                                    </div>

                                    <b className="tp-34">
                                        {data.data.order_status[status.id] || 0}
                                    </b>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default memo(OrderState);